import { __awaiter } from "tslib";
/**
 * Created by wuyanbin on 2019/5/13
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { uniqueArr } from '@/shared/functions';
import Mapping from '@/shared/mapping';
const initData = {
    tableData: [],
    totalNumber: 0,
    transferData: {},
    pageCurrent: 1,
    pageSize: 20,
    searchData: {},
    currentSelectTab: '0',
    // 过滤框时间label
    filterTime: '申请时间',
    visibleDaYuModal: false,
    // 导出的参数
    exportObjParams: {},
};
export default createStore({
    state: Object.assign({}, initData),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        RESET_STATE(state) {
            return Object.assign({}, initData);
        },
        HIDE_DAYU_MODAL(state) {
            state.visibleDaYuModal = false;
            state.transferData = {};
        },
        SHOW_DAYU_MODAL(state) {
            state.visibleDaYuModal = true;
        },
        SAVE_DaYu_TYPE(state, { actionType, orderTag, sellerPriceYuanUnit }) {
            state.actionType = actionType;
            state.orderTag = orderTag;
            state.sellerPriceYuanUnit = sellerPriceYuanUnit;
        },
        resetTableData(state) {
            state.tableData = [];
            state.pageCurrent = 1;
            state.tableNumber = 0;
        },
    },
    effects: {
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        // 更改tab
        changeTab(tab, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.SET_STATE({
                    currentSelectTab: tab,
                    filterTime: tab === '0' ? '申请时间' : '处理时间',
                });
            });
        },
        // 查看争议原因
        checkDispute(data, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { disputeCode } = data;
                // console.log(data,'0000000');
                Api.order.getCheckDisputeReason({ disputeCode }).then((data) => {
                    // console.log(data,'data222222');
                    if (data) {
                        this.SET_STATE({
                            transferData: data,
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
        // desc 更新表格
        updateTable(index, { state }) {
            const { searchData, pageSize } = state;
            console.log(searchData, 'searchData');
            const searchParams = {
                provinceCode: searchData && searchData.provinceCode ? searchData.provinceCode : '',
                cityCode: searchData && searchData.cityCode ? searchData.cityCode : '',
                license: searchData && searchData.license ? searchData.license : '',
                sellerPhone: searchData && searchData.sellerPhone ? searchData.sellerPhone : '',
                vinCode: searchData && searchData.vinCode ? searchData.vinCode : '',
                sellerCode: searchData && searchData.sellerCode ? searchData.sellerCode : '',
                buyerName: searchData && searchData.buyerName ? searchData.buyerName : '',
                buyerPhone: searchData && searchData.buyerPhone ? searchData.buyerPhone : '',
                disputeCreateStartTime: searchData && Number(searchData.currentSelectTab) === 0 && searchData.startTimeStr ? searchData.startTimeStr : '',
                disputeCreateEndTime: searchData && Number(searchData.currentSelectTab) === 0 && searchData.endTimeStr ? searchData.endTimeStr : '',
                disputeOverStartTime: searchData && Number(searchData.currentSelectTab) === 1 && searchData.startTimeStr ? searchData.startTimeStr : '',
                disputeOverEndTime: searchData && Number(searchData.currentSelectTab) === 1 && searchData.endTimeStr ? searchData.endTimeStr : '',
                disputeStatus: searchData && searchData.currentSelectTab ? searchData.currentSelectTab : '0',
                pageSize,
                pageCurrent: index ? index : 1,
            };
            Api.order.getDisputeListPage(searchParams).then((res) => {
                console.log(searchData.currentSelectTab === '0' ? Mapping.excelExportType.dispute_wait.value : Mapping.excelExportType.dispute_end.value);
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    totalNumber: res.totalNumber,
                    pageCurrent: res.currentIndex,
                    exportObjParams: Object.assign(Object.assign({}, searchParams), { totalCount: res.totalNumber, exportType: searchData.currentSelectTab === '0' ? Mapping.excelExportType.dispute_wait.value : Mapping.excelExportType.dispute_end.value }),
                });
            });
        },
    },
});
